// extracted by mini-css-extract-plugin
export default {"title":"EmployeeListeningCard_title__OrLMf","description":"EmployeeListeningCard_description__qBzMn"};